import { Box } from "@mui/material";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import AddTaskIcon from "@mui/icons-material/AddTask";
import CancelIcon from "@mui/icons-material/Cancel";

interface StatusBadgeProps {
  status: string;
}

const StatusBadge = ({ status }: StatusBadgeProps) => {
  const getStatusStyles = (status: string) => {
    let styles = {
      backgroundColor: "#f5f5f5",
      color: "#595959",
      icon: null,
    } as any;

    switch (status) {
      case "Pending Approval":
        styles = {
          backgroundColor: "#CCD7E7",
          color: "#0050b3",
          icon: <HourglassBottomIcon fontSize="small" />,
        };
        break;
      case "Approved":
        styles = {
          backgroundColor: "#BCEDAF",
          color: "#389e0d",
          icon: <AddTaskIcon fontSize="small" />,
        };
        break;
      case "Open":
        styles = {
          backgroundColor: "#D9D9D9",
          color: "#595959",
          icon: <RadioButtonUncheckedIcon fontSize="small" />,
        };
        break;
      case "Inprogress":
        styles = {
          backgroundColor: "#D3DEEE",
          color: "#5287D4",
          icon: <HourglassBottomIcon fontSize="small" />,
        };
        break;
      case "Completed":
        styles = {
          backgroundColor: "#BCEDAF",
          color: "#389e0d",
          icon: <AddTaskIcon fontSize="small" />,
        };
        break;
      case "Failed":
        styles = {
          backgroundColor: "#FFD9B2",
          color: "#d4380d",
          icon: <CancelIcon fontSize="small" />,
        };
        break;
      default:
        styles = { backgroundColor: "#f5f5f5", color: "#595959", icon: null };
        break;
    }

    return styles;
  };

  const { backgroundColor, color, icon } = getStatusStyles(status);

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "left",
        justifyContent: "center",
        backgroundColor,
        color,
        fontWeight: "bold",
        fontSize: "0.85rem",
        padding: "0.4rem 0.8rem",
        minWidth: "80px",
        borderRadius: "4px",
      }}
    >
      {icon && (
        <Box
          sx={{ marginRight: "0.3rem", display: "flex", alignItems: "center" }}
        >
          {icon}
        </Box>
      )}
      {status}
    </Box>
  );
};

export default StatusBadge;
